import React, { useState } from 'react';
import { ReactComponent as ChevRonDown } from '../../../assets/icons/chevron-down-outline.svg';
import { ReactComponent as ChevRonUp } from '../../../assets/icons/chevron-up-outline.svg';
import DetailTransaction from '../../../components/Transaction/DetailTransaction';
const TransactionAll = () => {
  // const [showTransaction, setShowTransaction] = useState(0);
  const [activeTransactionIndex, setActiveTransactionIndex] = useState(null);

  const toggleTransaction = (transactionIndex) => {
    if (activeTransactionIndex === transactionIndex)
      setActiveTransactionIndex(null);
    else setActiveTransactionIndex(transactionIndex);
  };
  return (
    <div className="flex flex-col">
      <div className="flex bg-gray-300">
        <div className="px-6 py-4 text-gray-600 leading-4 tracking-wider w-4/12">
          #Transaksi
        </div>
        <div className="px-6 py-4 text-gray-600 leading-4 tracking-wider w-3/12">
          Diantar
        </div>
        <div className="px-6 py-4 text-gray-600 leading-4 tracking-wider w-3/12">
          Nama
        </div>
        <div className="px-6 py-4 text-gray-600 leading-4 tracking-wider w-3/12">
          Sub total
        </div>
        <div className="px-6 py-4 text-gray-600 leading-4 tracking-wider w-3/12">
          Ongkir
        </div>
        <div className="px-6 py-4 text-gray-600 leading-4 tracking-wider w-3/12">
          Total
        </div>
        <div className="px-6 py-4 text-gray-600 leading-4 tracking-wider w-3/12">
          Status
        </div>
      </div>
      {/* Items 1 */}
      <div className="flex bg-white text-sm">
        <div className="px-6 py-4 text-gray-800 leading-4 tracking-wider w-4/12">
          <div
            className="flex items-center cursor-pointer"
            onClick={() => {
              toggleTransaction(1);
            }}
          >
            {activeTransactionIndex === 1 ? (
              <ChevRonUp className="h-6 w-6 mr-2" alt="Icon" />
            ) : (
              <ChevRonDown className="h-6 w-6 mr-2 " alt="Icon" />
            )}
            <p className="text-sm leading-5 text-gray-800">AT0G765HH24</p>
          </div>
        </div>
        <div className="px-6 py-4 text-gray-800 leading-4 tracking-wider w-3/12">
          {' '}
          <div className="flex flex-col items-start">
            <span className="relative inline-block px-4 py-1 text-sm bg-green-100 text-white rounded-md">
              Besok
            </span>
            <p className="text-gray-600 mt-2">07:00 - 08:00</p>
          </div>
        </div>
        <div className="px-6 py-4 text-gray-800 leading-4 tracking-wider w-3/12">
          <div className="flex flex-col">
            <p className="text-font-gray my-1">Stevani</p>
            <p className="text-font-gray my-1">082143433920</p>
          </div>
        </div>
        <div className="px-6 py-4 text-gray-800 leading-4 tracking-wider w-3/12">
          <p> Rp 10.000</p>
        </div>
        <div className="px-6 py-4 text-gray-800 leading-4 tracking-wider w-3/12">
          <p> Rp 20.000</p>
        </div>
        <div className="px-6 py-4 text-gray-800 leading-4 tracking-wider w-3/12">
          <p>Rp 30.000</p>
        </div>
        <div className="px-6 py-4 text-gray-800 leading-4 tracking-wider w-3/12">
          <button className=" flex items-center px-5 py-2 border-orange-500 border bg-orange-linen-500 text-orange-500 rounded transition duration-300 hover:bg-orange-600 hover:text-white focus:outline-none">
            <span className="mr-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20.12"
                height="19.716"
                viewBox="0 0 20.12 19.716"
              >
                <g
                  id="Iconly_Light_Buy"
                  data-name="Iconly/Light/Buy"
                  transform="translate(-1.883 -2.383)"
                >
                  <g id="Buy" transform="translate(2 2.5)">
                    <path
                      id="Stroke_1"
                      data-name="Stroke 1"
                      d="M.764,0A.765.765,0,1,1,0,.765.766.766,0,0,1,.764,0Z"
                      transform="translate(4.658 17.32)"
                      fill="none"
                      stroke="#f68906"
                      strokeLinecap="round"
                      stroke-linejoin="round"
                      stroke-miterlimit="10"
                      strokeWidth="1.5"
                    />
                    <path
                      id="Stroke_3"
                      data-name="Stroke 3"
                      d="M.765,0A.765.765,0,1,1,0,.765.766.766,0,0,1,.765,0Z"
                      transform="translate(15.91 17.32)"
                      fill="none"
                      stroke="#f68906"
                      strokeLinecap="round"
                      stroke-linejoin="round"
                      stroke-miterlimit="10"
                      strokeWidth="1.5"
                    />
                    <path
                      id="Stroke_5"
                      data-name="Stroke 5"
                      d="M0,0,2.08.36l.963,11.473a1.8,1.8,0,0,0,1.8,1.653H15.752a1.8,1.8,0,0,0,1.785-1.546l.949-6.558a1.341,1.341,0,0,0-1.327-1.533H2.414"
                      transform="translate(0.75 0.75)"
                      fill="none"
                      stroke="#f68906"
                      strokeLinecap="round"
                      stroke-linejoin="round"
                      stroke-miterlimit="10"
                      strokeWidth="1.5"
                    />
                    <path
                      id="Stroke_7"
                      data-name="Stroke 7"
                      d="M0,.5H2.773"
                      transform="translate(7.125 7.795)"
                      fill="none"
                      stroke="#f68906"
                      strokeLinecap="round"
                      stroke-linejoin="round"
                      stroke-miterlimit="10"
                      strokeWidth="1.5"
                    />
                  </g>
                </g>
              </svg>
            </span>
            Dipesan
          </button>
        </div>
      </div>
      {activeTransactionIndex === 1 ? <DetailTransaction /> : null}

      {/* Items 1 End */}
      {/* Items 2 */}
      <div className="flex bg-white text-sm">
        <div className="px-6 py-4 text-gray-800 leading-4 tracking-wider w-4/12">
          <div
            className="flex items-center cursor-pointer"
            onClick={() => {
              toggleTransaction(2);
            }}
          >
            {activeTransactionIndex === 2 ? (
              <ChevRonUp className="h-6 w-6 mr-2" alt="Icon" />
            ) : (
              <ChevRonDown className="h-6 w-6 mr-2 " alt="Icon" />
            )}
            <p className="text-sm leading-5 text-gray-800">AT0G765HH24</p>
          </div>
        </div>
        <div className="px-6 py-4 text-gray-800 leading-4 tracking-wider w-3/12">
          {' '}
          <div className="flex flex-col items-start">
            <span className="relative inline-block px-4 py-1 text-sm bg-green-100 text-white rounded-md">
              Besok
            </span>
            <p className="text-gray-600 mt-2">07:00 - 08:00</p>
          </div>
        </div>
        <div className="px-6 py-4 text-gray-800 leading-4 tracking-wider w-3/12">
          <div className="flex flex-col">
            <p className="text-font-gray my-1">Stevani</p>
            <p className="text-font-gray my-1">082143433920</p>
          </div>
        </div>
        <div className="px-6 py-4 text-gray-800 leading-4 tracking-wider w-3/12">
          <p> Rp 10.000</p>
        </div>
        <div className="px-6 py-4 text-gray-800 leading-4 tracking-wider w-3/12">
          <p> Rp 20.000</p>
        </div>
        <div className="px-6 py-4 text-gray-800 leading-4 tracking-wider w-3/12">
          <p>Rp 30.000</p>
        </div>
        <div className="px-6 py-4 text-gray-800 leading-4 tracking-wider w-3/12">
          <button className=" flex items-center px-5 py-2 border-orange-500 border bg-orange-linen-500 text-orange-500 rounded transition duration-300 hover:bg-orange-600 hover:text-white focus:outline-none">
            <span className="mr-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20.12"
                height="19.716"
                viewBox="0 0 20.12 19.716"
              >
                <g
                  id="Iconly_Light_Buy"
                  data-name="Iconly/Light/Buy"
                  transform="translate(-1.883 -2.383)"
                >
                  <g id="Buy" transform="translate(2 2.5)">
                    <path
                      id="Stroke_1"
                      data-name="Stroke 1"
                      d="M.764,0A.765.765,0,1,1,0,.765.766.766,0,0,1,.764,0Z"
                      transform="translate(4.658 17.32)"
                      fill="none"
                      stroke="#f68906"
                      strokeLinecap="round"
                      stroke-linejoin="round"
                      stroke-miterlimit="10"
                      strokeWidth="1.5"
                    />
                    <path
                      id="Stroke_3"
                      data-name="Stroke 3"
                      d="M.765,0A.765.765,0,1,1,0,.765.766.766,0,0,1,.765,0Z"
                      transform="translate(15.91 17.32)"
                      fill="none"
                      stroke="#f68906"
                      strokeLinecap="round"
                      stroke-linejoin="round"
                      stroke-miterlimit="10"
                      strokeWidth="1.5"
                    />
                    <path
                      id="Stroke_5"
                      data-name="Stroke 5"
                      d="M0,0,2.08.36l.963,11.473a1.8,1.8,0,0,0,1.8,1.653H15.752a1.8,1.8,0,0,0,1.785-1.546l.949-6.558a1.341,1.341,0,0,0-1.327-1.533H2.414"
                      transform="translate(0.75 0.75)"
                      fill="none"
                      stroke="#f68906"
                      strokeLinecap="round"
                      stroke-linejoin="round"
                      stroke-miterlimit="10"
                      strokeWidth="1.5"
                    />
                    <path
                      id="Stroke_7"
                      data-name="Stroke 7"
                      d="M0,.5H2.773"
                      transform="translate(7.125 7.795)"
                      fill="none"
                      stroke="#f68906"
                      strokeLinecap="round"
                      stroke-linejoin="round"
                      stroke-miterlimit="10"
                      strokeWidth="1.5"
                    />
                  </g>
                </g>
              </svg>
            </span>
            Dipesan
          </button>
        </div>
      </div>
      {activeTransactionIndex === 2 ? <DetailTransaction /> : null}

      {/* Items 2 End */}
      {/* Items 3*/}
      <div className="flex bg-white text-sm">
        <div className="px-6 py-4 text-gray-800 leading-4 tracking-wider w-4/12">
          <div
            className="flex items-center cursor-pointer"
            onClick={() => {
              toggleTransaction(3);
            }}
          >
            {activeTransactionIndex === 3 ? (
              <ChevRonUp className="h-6 w-6 mr-2" alt="Icon" />
            ) : (
              <ChevRonDown className="h-6 w-6 mr-2 " alt="Icon" />
            )}
            <p className="text-sm leading-5 text-gray-800">AT0G765HH24</p>
          </div>
        </div>
        <div className="px-6 py-4 text-gray-800 leading-4 tracking-wider w-3/12">
          {' '}
          <div className="flex flex-col items-start">
            <span className="relative inline-block px-4 py-1 text-sm bg-green-100 text-white rounded-md">
              Besok
            </span>
            <p className="text-gray-600 mt-2">07:00 - 08:00</p>
          </div>
        </div>
        <div className="px-6 py-4 text-gray-800 leading-4 tracking-wider w-3/12">
          <div className="flex flex-col">
            <p className="text-font-gray my-1">Stevani</p>
            <p className="text-font-gray my-1">082143433920</p>
          </div>
        </div>
        <div className="px-6 py-4 text-gray-800 leading-4 tracking-wider w-3/12">
          <p> Rp 10.000</p>
        </div>
        <div className="px-6 py-4 text-gray-800 leading-4 tracking-wider w-3/12">
          <p> Rp 20.000</p>
        </div>
        <div className="px-6 py-4 text-gray-800 leading-4 tracking-wider w-3/12">
          <p>Rp 30.000</p>
        </div>
        <div className="px-6 py-4 text-gray-800 leading-4 tracking-wider w-3/12">
          <button className=" flex items-center px-5 py-2 border-orange-500 border bg-orange-linen-500 text-orange-500 rounded transition duration-300 hover:bg-orange-600 hover:text-white focus:outline-none">
            <span className="mr-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20.12"
                height="19.716"
                viewBox="0 0 20.12 19.716"
              >
                <g
                  id="Iconly_Light_Buy"
                  data-name="Iconly/Light/Buy"
                  transform="translate(-1.883 -2.383)"
                >
                  <g id="Buy" transform="translate(2 2.5)">
                    <path
                      id="Stroke_1"
                      data-name="Stroke 1"
                      d="M.764,0A.765.765,0,1,1,0,.765.766.766,0,0,1,.764,0Z"
                      transform="translate(4.658 17.32)"
                      fill="none"
                      stroke="#f68906"
                      strokeLinecap="round"
                      stroke-linejoin="round"
                      stroke-miterlimit="10"
                      strokeWidth="1.5"
                    />
                    <path
                      id="Stroke_3"
                      data-name="Stroke 3"
                      d="M.765,0A.765.765,0,1,1,0,.765.766.766,0,0,1,.765,0Z"
                      transform="translate(15.91 17.32)"
                      fill="none"
                      stroke="#f68906"
                      strokeLinecap="round"
                      stroke-linejoin="round"
                      stroke-miterlimit="10"
                      strokeWidth="1.5"
                    />
                    <path
                      id="Stroke_5"
                      data-name="Stroke 5"
                      d="M0,0,2.08.36l.963,11.473a1.8,1.8,0,0,0,1.8,1.653H15.752a1.8,1.8,0,0,0,1.785-1.546l.949-6.558a1.341,1.341,0,0,0-1.327-1.533H2.414"
                      transform="translate(0.75 0.75)"
                      fill="none"
                      stroke="#f68906"
                      strokeLinecap="round"
                      stroke-linejoin="round"
                      stroke-miterlimit="10"
                      strokeWidth="1.5"
                    />
                    <path
                      id="Stroke_7"
                      data-name="Stroke 7"
                      d="M0,.5H2.773"
                      transform="translate(7.125 7.795)"
                      fill="none"
                      stroke="#f68906"
                      strokeLinecap="round"
                      stroke-linejoin="round"
                      stroke-miterlimit="10"
                      strokeWidth="1.5"
                    />
                  </g>
                </g>
              </svg>
            </span>
            Dipesan
          </button>
        </div>
      </div>
      {activeTransactionIndex === 3 ? <DetailTransaction /> : null}

      {/* Items 3 End */}
    </div>
  );
};

export default TransactionAll;
